import renderPage from '@helpers/renderPage';
const CompanyUserForm = ({ form, visible, onSuccess, onClose, translations }) => {
    const formRef = React.useRef(null);
    const formData = React.useRef({});
    const formHandler = React.useRef(null);

    React.useEffect(() => {
        if (!form || !visible) return;
        
        renderAlpacaForm();

        return () => {
            if (formRef.current) {
                $(formRef.current).alpaca('destroy');
            }
            formHandler.current = null;
        };
    }, [form, visible]);

    const onSubmitHandler = () => {
        $.ajax({
            type: 'post',
            url: '/api/users',
            data: JSON.stringify(formData.current),
            contentType: 'application/json; charset=utf-8',
            success: function (response, textStatus, xhr) {
                if (response.user) {
                    onSuccess(response.user, response.notification);
                    onClose();
                }
                formHandler.current.reset();
            },
            error: function (response) {
                notification(response.message, { type: 'error' });
            },
        });
    };

    const renderAlpacaForm = () => {
        formHandler.current = new alpacaForm();
        const dataSchema = _.cloneDeep(form);
        formHandler.current.postRender = function () {
            return function (control) {
                const $container = control.domEl,
                    $form = $container.closest('.ta-form');
                formHandler.current.defaultPostRender(control);
                const $submitButtons = $form.find('[type="submit"]');
                $submitButtons.on('valid-click', (e, data) => {
                    onSubmitHandler();
                    data.alwaysCb();
                    return false;
                });
            };
        };

        Object.keys(dataSchema['options']['fields']).forEach(function (key) {
            dataSchema['options']['fields'][key]['events'] = {
                change: function (event) {
                    event.preventDefault();
                    formData.current = { ...formData.current, [this.name]: this.getValue() };
                },
            };
        });

        formHandler.current.init(null, $(formRef.current));
        formHandler.current.updateJsonConfiguration(dataSchema);
    };

    return (
        <div className="ta-form spacing-bottom-l" style={{ display: (!form || !visible) ? 'none' : 'block' }}>
            <div ref={formRef}></div>
            <div className="btn-container text-right">
                {typeof onClose === 'function' && (
                    <button className="btn btn-ghost" onClick={onClose}>
                        {translations['cancel'] || 'Cancel'}
                    </button>
                )}
                <button type="submit" className="btn btn-primary">
                    {translations['invite'] || 'Invite'}
                </button>
            </div>
        </div>
    );
};

CompanyUserForm.defaultProps = {
    onSuccess: () => {},
    translations: {},
    onClose: () => {},
};

window.CompanyUserForm = CompanyUserForm;

window.renderAddUserForm = (id, props = {}) => {
    const { visible = true, form, onSuccess, onClose } = props;
    renderPage(id, () => (
        <CompanyUserForm
            visible={visible}
            form={form}
            onSuccess={onSuccess}
            onClose={onClose}
            {...props}
        />
    ));
};
